const faces = [
    ['SyncroQrIntro', 'Intro.otf', 400, 'opentype'],
    ['SyncroQrSugo', 'Sugo-Pro-Display-Regular-trial.ttf', 400, 'truetype'],
    ['SyncroQrJimmy', 'JimmyScript-Rg.otf', 400, 'opentype'],
    ['SyncroQrPublicSans', 'PublicSans-Regular.otf', 400, 'opentype'],
    ['SyncroQrPublicSans', 'PublicSans-Bold.otf', 700, 'opentype'],
];

export const qrFontCss = faces.map(([family, file, weight, format]) =>
    `@font-face { font-family: '${family}'; src: url('/assets/fonts/${file}') format('${format}'); font-weight: ${weight}; font-style: normal; font-display: swap; }`
).join('\n');

export async function waitForQrFonts(document) {
    if (!document.fonts) throw new Error('Font loading API unavailable');
    const loaded = await Promise.all(faces.map(([family, , weight]) =>
        document.fonts.load(`${weight} 16px "${family}"`)
    ));
    if (loaded.some(fonts => !fonts.length)) throw new Error('Missing QR font');
    await document.fonts.ready;
}
